import { useNavigate } from "react-router-dom"
import { Typography } from "@mui/material"

import StyledPaper from "/components/paper"

import image from '/assets/dashboard/apps.png'

const DownloadApps = () => {

  const navigate = useNavigate()

  return (
    <StyledPaper classes="w-[250px] h-[250px]">
      <div onClick={() => navigate("/download-apps")} className="link flex flex-col items-center justify-top h-full">
        <Typography variant="h5">Download Apps</Typography>
      </div>
      <div onClick={() => navigate("/download-apps")} className="link relative">
        <img src={image} style={{ position: "absolute", left:"50%",bottom: 20, height: "150px", display: "inline-block", transform: "rotate(5deg) translateX(-50%)", filter: "drop-shadow(0 8px 12px rgba(0, 0, 0, 1))", maskImage:"linear-gradient(to top, transparent 0%, black 25%, black 100%)"}} />
      </div>
    </StyledPaper>
  )
}

export default DownloadApps